<template>
  <div class="message-list">
    <div v-for="message in messages" :key="message.id">
      <div class="message-time">
        {{ message.createdDate }}
      </div>
      <div :class="getClassName(message)" class="message-item">
        <el-avatar v-if="message.isReply" :size="35" class="avatar" src="/home/img/assistant.svg"></el-avatar>
        <el-avatar v-else :size="35" class="avatar" :src="getAvatarUrl()"></el-avatar>
        <div class="message-bubble" style="white-space: pre-wrap">
          <template v-if="isImage(message)">
            <el-link :underline="false" :href="getStorageUrl(message)" target="_blank">
              <el-image :src="getStorageUrl(message)" lazy>
                <template #placeholder>
                  <div class="image-slot">
                    加载中
                    <span class="dot">...</span>
                  </div>
                </template>
              </el-image>
            </el-link>
          </template>
          <template v-else-if="isDocument(message)">
            <el-link :underline="false" target="_blank" :href="getStorageUrl(message)">
              <div class="message-document">
                <i class="el-icon-paperclip"></i>
                <span v-html="message.content" style="word-break: break-all;"></span>
              </div>
            </el-link>
          </template>
          <template v-else>
            <span v-html="message.content" style="word-break: break-all;"></span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ITicketMessage, IUser } from '@/types/models';
import { MessageType } from '@/types/enums';
import utils from '@/utils';

export default defineComponent({
  name: 'MessageList',
  props: {
    user: {
      type: Object as PropType<IUser>,
      required: true,
    },
    messages: {
      type: Object as PropType<ITicketMessage[]>,
      required: true,
    },
    isReply: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    getClassName(message: ITicketMessage) {
      if (this.isReply) {
        return message.isReply ? 'message-item--right' : 'message-item--left';
      }
      return message.isReply ? 'message-item--left' : 'message-item--right';
    },

    isImage(message: ITicketMessage) {
      return message.messageType === MessageType.Image;
    },

    isDocument(message: ITicketMessage) {
      return message.messageType === MessageType.Document;
    },

    getStorageUrl(message: ITicketMessage) {
      return utils.getStorageUrl(message.storageKey);
    },

    getAvatarUrl() {
      return utils.getAvatarUrl(this.user);
    },

    getFileName(url: string) {
      return utils.getFileName(url);
    },
  },
});
</script>
<style scoped>
.message-list {
  font-size: 16px;
  background-color: #ebebeb;
  overflow-y: auto;
  padding-bottom: 20px;
  padding-top: 20px;
}

.message-item {
  width: 100%;
  display: flex;
  margin-top: 8px;
}

.message-item .avatar {
  margin: 0 10px;
}

.message-item--right {
  flex-direction: row-reverse;
}

.message-time {
  text-align: center;
  font-size: 12px;
  color: #999;
  line-height: 20px;
  margin-bottom: 0;
  margin-top: 10px;
  display: block;
}

.message-bubble {
  border: 1px solid #ddd;
  padding: 7px 10px;
  border-radius: 3px;
  max-width: 80%;
  position: relative;
}

.message-item--left .message-bubble {
  background-color: #fff;
}
.message-item--left .message-bubble::before {
  content: '';
  width: 10px;
  height: 10px;
  background: #fff;
  top: 14px;
  left: -6px;
  transform: rotate(-45deg);
  border-radius: 0 0 20px 0;
}

.message-item--right .message-bubble {
  /* background-color: #afe56e;
    border-color: #7fb25a; */
  background-color: #9fe759;
  border-color: #87cd51;
}

.message-item--right .message-bubble::before {
  content: '';
  width: 10px;
  height: 10px;
  background-color: #9fe759;
  top: 14px;
  right: -6px;
  transform: rotate(135deg);
  border-radius: 0 0 20px 0;
}

.message-document {
  width: 200px;
  text-align: center;
  font-size: 16px;
  color: #000;
}

.message-document i {
  display: block;
  font-size: 32px;
  margin-top: 15px;
  margin-bottom: 15px;
  color: #000;
}

.message-document span {
  display: inline-block;
  padding: 0 3px;
  margin-bottom: 15px;
}
</style>
